import { render, staticRenderFns } from "./staff_accesses.vue?vue&type=template&id=59854f16&scoped=true"
import script from "./staff_accesses.vue?vue&type=script&lang=js"
export * from "./staff_accesses.vue?vue&type=script&lang=js"
import style0 from "./staff_accesses.vue?vue&type=style&index=0&id=59854f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59854f16",
  null
  
)

export default component.exports